/** @format */

import React, { useEffect } from "react";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { Form } from "react-bootstrap";
import { parseLocation } from "../../../lib/parseLocation";

// const customStyles = {
//   position: "absolute",
//   zIndex: "1",
// };

const GoogleApi = ({ dispatch, address, setAddress }) => {
  const searchOptions = {
    types: ["(regions)"],
    componentRestrictions: { country: ["US", "CA"] },
  };

  const handleSelect = async (input) => {
    try {
      const address = await geocodeByAddress(input);
      console.log(address);
      const coordinates = await getLatLng(address[0]);
      console.log(coordinates);
      const stateNames = address[0].formatted_address.split(",");
      console.log(stateNames);

      const locationValues = parseLocation({ input: stateNames });
      dispatch({
        type: "HANDLE_CHANGE_GOOGLEPLACES",
        payload: {
          address: address,
          coordinates: coordinates,
          stateNames: {
            city: locationValues[0],
            state: locationValues[1],
          },
        },
      });
      setAddress(input);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    let radius = document.getElementById("radius-search");
    let stateOnly = document.getElementById("stateOnlyFilter");
    if (address.length > 0) {
      if (radius) radius.disabled = false;
      if (stateOnly) stateOnly.disabled = false;
    } else {
      dispatch({ type: "CLEAR_LOCATION_PARAMS" });
      if (radius) radius.disabled = true;
      if (stateOnly) stateOnly.disabled = true;
    }
  }, [address, dispatch]);

  return (
    <PlacesAutocomplete
      onChange={(address) => setAddress(address)}
      value={address}
      onSelect={handleSelect}
      searchOptions={searchOptions}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <Form.Group className="col-lg-2 col-md-4 form-group position-relative">
          <Form.Label>Search by Location</Form.Label>
          <div className="">
            <Form.Control
              className="google-places-wrapper"
              {...getInputProps({
                placeholder: "Enter City",
                className: "filter-search form-control",
                type: "text",
              })}
            />
            {loading && (
              <div className="position-absolute t-2  r-0 btn btn-transparent">
                <div
                  className="spinner-border spinner-border-sm text-primary"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}
          </div>

          <div
            id="autocomplete-dropdown-container"
            className="position-absolute shadow-sm w-100 "
            style={{ zIndex: "99" }}
          >
            {suggestions.map((suggestion) => {
              const id = suggestion.active
                ? "suggestion-item--active"
                : "suggestion-item";
              // inline style for demonstration purpose
              const style = suggestion.active
                ? {
                    backgroundColor: "#fafafa",
                    cursor: "pointer",
                    width: "100",
                    padding: "1rem",
                  }
                : {
                    backgroundColor: "#ffffff",
                    cursor: "pointer",
                    width: "100",
                    padding: "1rem",
                  };
              return (
                <div
                  key={suggestion.placeId}
                  {...getSuggestionItemProps(suggestion, {
                    id,
                    style,
                  })}
                >
                  <span>{suggestion.description}</span>
                </div>
              );
            })}
          </div>
        </Form.Group>
      )}
    </PlacesAutocomplete>
  );
};

export default GoogleApi;
